import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

export const ProfileCompany = (props) => {
    const mobile = props.objectData.owner.mobile;
    const phone = props.objectData.owner.phone;

    const renderPhoneInformation = () => (
        <div>
            <span data-testid="phoneType">{phone ? 'Telefon: ' : 'Mobil: '}</span>
            <span>
                <a data-testid="companyPhone" href={`tel:${phone ? phone : mobile}`} rel="external">
                    {phone ? phone : mobile}
                </a>
            </span>
        </div>
    );

    return (
        <div className="mb-16" data-testid="companyProfile">
            {props.objectData.organisation.logo?.trim().length > 0 ? (
                <img
                    data-testid="logo"
                    className={cn(styles.logo, 'img-format__img')}
                    alt={props.objectData.organisation.name}
                    src={`https://images.finncdn.no/dynamic/1600w/logo/${props.objectData.organisation.logo}`}
                />
            ) : null}
            <div className="mt-4" data-testid="ownerName">
                {props.objectData.owner.name}
            </div>
            {phone || mobile ? renderPhoneInformation() : null}
        </div>
    );
};

ProfileCompany.propTypes = {
    objectData: PropTypes.object.isRequired,
};
